import request from '@/utils/request'

// 查询【请填写功能名称】列表
export function listInquiries(query) {
  return request({
    url: '/system/inquiries/list',
    method: 'get',
    params: query
  })
}

// 查询【请填写功能名称】详细
export function getInquiries(id) {
  return request({
    url: '/system/inquiries/' + id,
    method: 'get'
  })
}

// 新增【请填写功能名称】
export function addInquiries(data) {
  return request({
    url: '/system/inquiries',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateInquiries(data) {
  return request({
    url: '/system/inquiries',
    method: 'put',
    data: data
  })
}

// 删除【请填写功能名称】
export function delInquiries(id) {
  return request({
    url: '/system/inquiries/' + id,
    method: 'delete'
  })
}
